import PersonaPage from "./PersonaPage";
import { questionsPersonMale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für den Bruder?",
    a: "Beginnen Sie in der Kindheit — bei einem Streit, einem Spielzeug, einem Sommer. Bei Geschwistern trägt die frühe Zeit oft die ganze Rede, weil sie zeigt, wer Sie zusammen waren, bevor das Leben Sie zog.",
  },
  {
    q: "Wir haben uns als Erwachsene wenig gesehen. Wie soll ich sprechen?",
    a: "Ehrlich. Eine Rede darf sagen, dass Wege sich trennen und trotzdem etwas bleibt — das gemeinsame Zuhause, die gleichen Gesten, die Stimmen der Eltern in uns beiden. Genau darin liegt die Würde.",
  },
  {
    q: "Wie viel Humor darf in einer Rede für den Bruder sein?",
    a: "So viel, wie zu ihm gepasst hätte. Ein leises Lachen an der richtigen Stelle ist Erinnerung, nicht Respektlosigkeit.",
  },
  {
    q: "Können wir Kindheitsanekdoten einbinden?",
    a: "Sehr gern. Sie können im Fragebogen eine konkrete Geschichte hinterlegen — wir setzen sie behutsam in den Entwurf ein.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für die Schwester", to: "/trauerrede-schwester" },
  { label: "Trauerrede für den Vater", to: "/trauerrede-vater" },
  { label: "Trauerrede für einen Freund", to: "/trauerrede-freund" },
];

export default function TrauerredeBruder() {
  return (
    <PersonaPage
      slug="trauerrede-bruder"
      metaTitle="Trauerrede für den Bruder schreiben — persönlich & würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für den Bruder. Aus Kindheitserinnerungen und geteilten Jahren entsteht in acht behutsamen Fragen ein würdevoller Entwurf. Ab 29 €."
      eyebrow="Trauerrede · Bruder"
      headline={
        <>
          Eine Trauerrede für den Bruder.
          <br />
          <span className="italic text-umber">Die geteilten Jahre. In Ihren Worten.</span>
        </>
      }
      intro="Ein Bruder ist der Mensch, der die gleichen Kindheitsgeräusche kennt. Der weiß, wie das Treppenknarren klang. Ein behutsamer erster Entwurf — aus acht ruhigen Fragen und den Erinnerungen, die nur Geschwister haben."
      heroImage="https://images.unsplash.com/photo-1481207727306-1a9f151fca7d?w=1920&q=80"
      heroImageAlt="Zwei Kaffeetassen und ein aufgeschlagenes Notizbuch im warmen Licht — Sinnbild einer Trauerrede für den Bruder"
      questions={questionsPersonMale}
      exampleQuote={
        <>
          „Wir haben in demselben Zimmer geschlafen, bis er zwölf war. Ich weiß noch, wie er
          atmete, wenn er schlief. Ich weiß noch, welches Buch neben seinem Bett lag. Es gibt
          Dinge, die man nur weiß, wenn man den anderen kennt, bevor die Welt ihn kannte. Ich
          habe ihn so gekannt. Und ich werde ihn so behalten.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
